import { Tooltip as AntTooltip } from "antd";
import { SvgInfo, SvgInfoOutline } from "components/svg";
import type { HTMLAttributes } from "react";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";

interface TooltipProps extends HTMLAttributes<any> {
    text: string;
    icon?: any;
}
const Tooltip: React.FC<TooltipProps> = ({
    text,
    icon,
}) => {
    const { tHtml } = useTranslation();
    const { isThermor } = useSalesNetwork()

    return <>
        <group data-width="auto" data-space-horizontal="10">
            <AntTooltip
                arrow={false}
                //color="var(--accent-dark)"
                color="var(--white)"
                //space={false}

                title={
                    <group
                        //data-direction="column"
                        data-gap="10"
                        data-space="10"
                        //data-background="red"
                        data-color="black"
                        data-length="400"
                        data-text-size="medium"
                    >
                        {/* <pre dangerouslySetInnerHTML={{ __html: t("HELP_INERTIA")}}/> */}
                        {text && tHtml(text, null, "\n")}
                    </group>
                }
            >
                {isThermor ?
                    <icon data-svg-size="20" data-svg-color="secondary-light" data-cursor="pointer">{icon || <SvgInfoOutline />}</icon>
                    :
                    <icon data-svg-size="20" data-svg-color="secondary" data-cursor="pointer">{icon || <SvgInfo />}</icon>}
            </AntTooltip>
        </group>
    </>
}
export default Tooltip;